export function ListPropertiesRequest(token) {
  return {
    type: '@properties/LIST_PROPERTIES_REQUEST',
    payload: { token },
  };
}

export function ListPropertiesResponse(properties, totalPages) {
  return {
    type: '@properties/LIST_PROPERTIES_RESPONSE',
    payload: { properties, totalPages },
  };
}

export function GetDataSecondBilletRequest(
  token,
  contractId,
  page,
  totalPages
) {
  return {
    type: '@properties/GET_SECOND_BILLET_REQUEST',
    payload: { token, contractId, page, totalPages },
  };
}

export function GetDataSecondBilletResponse(data, totalPages) {
  return {
    type: '@properties/GET_SECOND_BILLET_RESPONSE',
    payload: { data, totalPages },
  };
}

export function GetReservationFundsRequest(
  token,
  contractId,
  pages,
  totalPages
) {
  return {
    type: '@properties/GET_RESERVATION_FUNDS_REQUEST',
    payload: { token, contractId, pages, totalPages },
  };
}

export function GetReservationFundsResponse(data, totalPages) {
  return {
    type: '@properties/GET_RESERVATION_FUNDS_RESPONSE',
    payload: { data, totalPages },
  };
}
